export const config = {
    fallbackLng: 'en',
    supportedLngs: ['en', 'zh-CN'], // Add this to limit supported languages
    load: 'languageOnly', // Add this to force "en" instead of "en-GB"
    detection: {
        // Add detection options
        order: ['localStorage', 'navigator'],
        caches: ['localStorage'],
    },
    backend: {
        apiPath: `api/v1/translation`,
    },
    defaultNS: 'common',
    ns: ['common'],
    interpolation: {
        escapeValue: false,
    },
    react: {
        useSuspense: false,
    },
};
